import { constants } from '../constants';

export default function paymentMethod(expenseText) {
  return expenseText === constants.PAYMENT_TYPES.ARRIVAL;
}
